export default __webpack_public_path__ + "static/media/Storyboard.c4350c73.svg";